import React from "react";
import { Form } from "antd";
import { UserOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { CUSTOM_COLORS } from "@/shared/theme/colorUtils";

const UsernameInputContainer = styled.div`
	position: relative;
	height: 36px;
	border-radius: 20px;
	border: 1px solid #d9d9d9;
	background: white;
	display: flex;
	align-items: center;
	padding: 0 12px;
	width: 100%;
	overflow: hidden;

	.username-input {
		flex: 1;
		min-width: 0;
		border: none;
		outline: none;
		background: transparent;
		font-size: 0.9rem;
		padding: 0;
		margin: 0;

		/* Stop text from clipping weirdly */
		width: 100%;

		&::placeholder {
			color: #999;
		}
	}

	&:hover,
	&:focus-within {
		border-color: ${CUSTOM_COLORS.PRIMARY};
	}

	.prefix-text {
		color: #999;
		font-size: 0.9rem;
		margin-right: 4px;
		pointer-events: none;
		white-space: nowrap; // Prevents the URL from wrapping to a second line
	}

	.username-input {
		border: none;
		outline: none;
		background: transparent;
		font-size: 0.9rem;
		padding: 0;
		margin: 0;
		&::placeholder {
			color: #999;
		}
	}
`;

interface UsernameStepProps {
	onUsernameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onMetaChange?: (meta: { checking: boolean; exists: boolean | null; isValid: boolean }) => void;
	exists?: boolean | null;
	checking?: boolean;
}

const UsernameStep: React.FC<UsernameStepProps> = ({ onUsernameChange, onMetaChange, exists, checking }) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		const isValid = /^[a-zA-Z0-9_]{3,20}$/.test(value);
		onMetaChange?.({ checking: false, exists: null, isValid });
		onUsernameChange(e);
	};

	return (
		<Form.Item
			name="username"
			label=""
			style={{ marginBottom: 26, marginTop: 40 }}
			validateStatus={exists === true ? "error" : checking ? "validating" : undefined}
			help={exists === true ? "Username already taken" : undefined}
			rules={[
				{ min: 3, message: "Username must be at least 3 characters!" },
				{ max: 20, message: "Username must be less than 20 characters!" },
				{ pattern: /^[a-zA-Z0-9_]+$/, message: "Username can only contain letters, numbers, and underscores!" },
			]}
		>
			<UsernameInputContainer>
				<UserOutlined style={{ marginRight: "8px", color: "#999" }} />
				<span className="prefix-text">thecreatorverse.co/</span>
				<input className="username-input" placeholder="username" onChange={handleChange} />
			</UsernameInputContainer>
		</Form.Item>
	);
};

export default UsernameStep;
